module.exports = __webpack_public_path__ + "media/memory-bank/courses_placeholder-dc7175cd.png";